import React, { Fragment, useState, useContext } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
//** Import Image */
import { Link } from "react-router-dom";
import patientPhoto from "../../../images/avatar/patient.png";
import woman from "../../../images/avatar/woman.png";

import Cookies from "js-cookie";
import { LanguageContext } from "../../../resources/languageContext";
import d from "../../../resources/dictionary.json";
import useFetch from "../../../helpers/useFetch";
import { Button, Modal, Row, Col, Card, Spinner, Tab, Nav, } from "react-bootstrap";
import PatientStats from "../../components/custom/PatientStats";
import Details from "../../components/custom/Details";
import Risk from "../../components/custom/Risk";
import { toast } from "react-toastify";
import Objectives from "../../components/custom/Objectives";
import Medication from "../../components/custom/Medication";
import Swal from "sweetalert2";
import "./PatientDetails.css"
import { CardBody } from "reactstrap";
import moment from "moment";

function PatientDetails() {
  const [activeToggle, setActiveToggle] = useState("details");
  const { language } = useContext(LanguageContext);
  const { id } = useParams();
  const history = useHistory();
  const { state: patient } = useLocation() || {};

  const [notifyMsg, setNotifyMsg] = useState({
    title: "",
    message: "",
  });
  const [showModal, setShowModal] = useState(false);

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    setNotifyMsg((prvMsg) => ({
      ...prvMsg,
      [name]: value,
    }));
  };

  const token = Cookies.get("jwt");
  const request = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const { data } = useFetch(
    `https://doctor.shls.care/api/doctor/patients/profile?id=${id}`,
    request
  );
  const handleUnfollow = () => {
    Swal.fire({
      text: d["do you really want to stop following this patient ?"][language],
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: d['confirm'][language]
    }).then((result) => {
      if (result.isConfirmed) {
        unfollowPatient()
      }
    })

  }

  const unfollowPatient = async () => {
    const request = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        patient_id: id,
        followId: patient.follow_doctor_id,
      }),
    };
    try {
      let response = await fetch(
        "https://doctor.shls.care/api/doctor/unfollow",
        request,
        {
          mode: "cors",
        }
      );
      if (response.status === 200) {
        toast.success(d["success"][language]);
        history.push("/patients");
      }
    } catch (error) {
      console.error(error.message);
    }

  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    const request = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        Notification_content: notifyMsg.message,
        Notification_title: notifyMsg.title,
        patient_id: id,
      }),
    };
    try {
      let response = await fetch(
        "https://doctor.shls.care/api/doctor/notification/push",
        request
      );
      if (response.status === 200) {
        toast.success(d["message sent"][language]);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setShowModal(false);
    }
  };


  return (
    <Fragment>
      <div className="patient page-titles pt-0 mb-0">
        <ol className="breadcrumb">
          <li className="breadcrumb-item fs-24">{d["patients"][language]}</li>
          <li className="breadcrumb-item active fs-24">{data?.patient?.patient_lastname}{" "}
            {data?.patient?.patient_firstname}</li>
        </ol>
      </div>
      <Modal
        centered
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        className="notification-modal modal fade"
      >
        <div className="modal-header d-flex align-items-center">
          <h5 className="modal-title fs-24" style={{ color: "#112361" }}>{d["send notification"][language]}</h5>
          <span
            type="button"
            onClick={() => {
              setShowModal(false);
            }}
            className="fs-24"
            data-dismiss="modal"
          >
            <span>&times;</span>
          </span>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className=" modal-label mt-3 fs-18" style={{ color: "#112361", opacity: "1" }}>
                {d["title"][language]}
              </label>
              <input
                style={{ color: "#112361", opacity: "1" }}
                required
                placeholder={d["title"][language]}
                type="text"
                className="form-control"
                name="title"
                value={notifyMsg.title}
                onChange={handleChange}
              />

              <label className=" font-w400 mt-3 fs-18" style={{ color: "#112361", opacity: "1" }}>
                {d["message"][language]}
              </label>
              <textarea
                style={{ color: "#112361", opacity: "1" }}
                required
                type="text"
                placeholder="message"
                className="form-control"
                name="message"
                value={notifyMsg.message}
                onChange={handleChange}
              />
            </div>
            <div className="text-center mt-4">
              <button type="submit" className="send-btn btn btn-block" >
                {d["send"][language]}
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <div className="row">
        <div className="col-8">
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-1">
                  {/* img */}
                  <img
                    src={
                      (() => {
                        if (data?.patient?.profil_picture != null) {
                          return "https://doctor.shls.care/pictures/" + data?.patient?.profil_picture
                        } else {
                          if ((data?.patient?.patient_sexe === "male") || (data?.patient?.patient_sexe === "Male")) {
                            return patientPhoto
                          } else {
                            return woman
                          }

                        }
                      })()
                    }
                    className="rounded-circle"
                    alt="user"
                    width="80"
                    height="80"
                  />
                </div>
                <div className="col-8 border-right text-wrapped" style={{ paddingLeft: "3rem", paddingRight: "2rem" }}>
                  <div className="border-bottom  d-flex justify-content-between">
                    <div className="">
                      <h6 className="fs-24 mb-0">
                        <span
                          className=" GoldmanSemiBold text-wrapped" style={{ color: "#3453DF" }}
                        >
                          {data?.patient?.patient_lastname}{" "}
                          {data?.patient?.patient_firstname}
                        </span>
                      </h6>
                      <p className="fs-18 GoldmanNormal  text-wrapped">{data?.patient?.patient_address && ", "}
                        {data?.patient?.patient_ville}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center text-center">
                      <div className="d-flex flex-column border-right px-4 mb-3">
                        <span className="GoldmanSemiBold fs-32">{moment().diff(data?.patient?.patient_birthday, "years")}</span>
                        <span className="fs-16 GoldmanNormal mb-0 label">Age</span>
                      </div>
                      <div className="d-flex flex-column border-right px-4 mb-3">
                        <div className="fs-32">
                          {
                            (data?.patient?.patient_sexe === "Male" || data?.patient?.patient_sexe === "male") ?

                              <svg width="28" height="28" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6145 0.989832C17.2262 1.06639 16.8652 1.3453 16.6629 1.72264C16.5699 1.89218 16.5426 2.03983 16.5426 2.35155C16.5426 2.8328 16.6629 3.10077 16.9855 3.39061C17.4012 3.75155 17.3465 3.74608 19.9004 3.76249L22.2246 3.77889L19.6652 6.33827L17.1004 8.90311L16.6027 8.57499C13.9887 6.85233 10.691 6.4203 7.74336 7.40468C4.02461 8.65155 1.41602 11.9328 0.978519 15.9195C0.901956 16.6141 0.945706 17.943 1.06602 18.6211C1.44336 20.7703 2.36211 22.5422 3.88243 24.0625C5.40821 25.5883 7.16914 26.4961 9.35117 26.8844C10.0512 27.0101 11.8121 27.0266 12.4957 26.9117C14.8418 26.5344 16.898 25.4406 18.4676 23.7344C20.6223 21.3883 21.5355 18.0086 20.8684 14.8476C20.6113 13.6391 20.0754 12.3703 19.3973 11.3695L19.0418 10.8445L21.6066 8.27968L24.166 5.7203L24.1824 8.07186C24.1988 10.6586 24.1934 10.5984 24.5543 11.0141C25.1996 11.7469 26.4191 11.5719 26.8621 10.675L26.9879 10.418L27.0043 6.34921C27.0152 3.59296 26.9988 2.18749 26.9606 1.99608C26.8785 1.59686 26.6379 1.29608 26.2605 1.11014L25.9488 0.95702L21.902 0.946081C19.6762 0.946081 17.7457 0.962488 17.6145 0.989832ZM12.1402 9.70702C13.2668 9.87655 14.4152 10.3414 15.323 10.9922C15.8973 11.4023 16.7121 12.2336 17.1059 12.8133C19.0582 15.657 18.7137 19.5891 16.302 22.0391C14.8801 23.4828 13.0699 24.243 11.0465 24.243C9.55352 24.243 8.23555 23.8437 6.97227 23.018C6.39805 22.6406 5.34805 21.5906 4.98164 21.0273C4.13946 19.7367 3.75118 18.4351 3.75664 16.8984C3.76211 15.6789 4.00274 14.6726 4.55508 13.5953C5.58321 11.5828 7.61758 10.0844 9.78867 9.73436C10.0129 9.70155 10.2371 9.66327 10.2809 9.65233C10.5324 9.60311 11.6918 9.63593 12.1402 9.70702Z" fill="#112361" />
                              </svg> :
                              <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.90619 0.054657C6.89915 0.306219 5.11634 1.07731 3.57415 2.357C0.287435 5.10231 -0.861003 9.69059 0.741341 13.6992C1.63822 15.9468 3.37728 17.8281 5.54837 18.9109C6.41244 19.3429 7.21634 19.6109 8.29368 19.8297C8.414 19.8515 8.414 19.8625 8.414 20.8031V21.7547L7.61009 21.7765C6.88822 21.7984 6.7679 21.8148 6.49994 21.9351C6.11712 22.1101 5.86009 22.3672 5.69056 22.7445C5.57572 22.9961 5.55931 23.0945 5.58118 23.4609C5.60853 23.9531 5.76165 24.2648 6.12259 24.5765C6.47259 24.8773 6.72962 24.9375 7.63197 24.9375H8.414V25.7742C8.414 26.8679 8.47415 27.0867 8.90072 27.5132C9.36556 27.9781 9.86322 28.0984 10.4921 27.9125C10.7163 27.8468 10.8585 27.7539 11.0992 27.5132C11.5257 27.0867 11.5859 26.8679 11.5859 25.7742V24.9375H12.3679C13.2702 24.9375 13.5273 24.8773 13.8773 24.5765C14.2327 24.2703 14.3859 23.9586 14.4187 23.4828C14.4515 22.9742 14.3421 22.6625 14.0085 22.307C13.6257 21.8968 13.3523 21.8039 12.3952 21.7765L11.5859 21.7547V20.8031C11.5859 19.8625 11.5859 19.8515 11.7117 19.8297C13.9812 19.3703 15.7312 18.4242 17.2242 16.8547C19.7835 14.164 20.6312 10.3414 19.4554 6.81403C18.2906 3.30856 15.2882 0.760124 11.5859 0.12575C11.0117 0.0273132 9.45853 -0.0109692 8.90619 0.054657ZM11.0827 3.25388C13.9484 3.71872 16.2179 5.97184 16.732 8.85934C16.8468 9.49919 16.8195 10.6914 16.6773 11.375C16.3874 12.7476 15.7476 13.8906 14.6921 14.9078C13.3906 16.1601 11.8265 16.789 9.99994 16.789C8.18431 16.789 6.59837 16.1492 5.29134 14.8914C4.26868 13.907 3.66165 12.8351 3.34447 11.4625C3.164 10.6914 3.14212 9.48825 3.28978 8.73356C3.85306 5.90622 6.07884 3.72966 8.87337 3.25934C9.47494 3.15544 10.4702 3.15544 11.0827 3.25388Z" fill="#112361"/>
                              </svg>
                              
                          }
                        </div>
                        <span className="fs-16 GoldmanNormal mb-0 label">{d["sex"][language]}</span>
                      </div>
                      <div className="d-flex flex-column  px-4 mb-3">
                        <span className="GoldmanSemiBold fs-32">{parseInt(data?.patient?.patient_height)}</span>
                        <span className="fs-16 GoldmanNormal mb-0 label">{d["height"][language]}</span>
                      </div>

                    </div>
                  </div>
                  <div className=" row justify-content-between mt-4 text-wrapped">

                    <div className="col-6 d-flex justify-content-between align-items-center">
                      <span className="fs-18 label">{d["phone"][language]}:</span>
                      <p className="fs-18 text-wrapped mb-0" style={{ width: '60%' }}>
                        {data?.patient?.patient_phonenumber}
                      </p>
                    </div>
                    <div className="col-6 d-flex justify-content-between align-items-center">
                      <span className="fs-18 label ">Groupe Sanguin:</span>
                      <p className="fs-18 mb-0">
                        {data?.patient?.blood_type}
                      </p>
                    </div>
                  </div>
                  <div className=" row justify-content-between">

                    <div className="col-12 d-flex justify-content-start align-items-center">
                      <span className="fs-18 label">Email:</span>
                      <a href={"mailto:"+data?.patient?.patient_email}>
                      <p className="fs-18 text-wrapped mb-0" >
                       {data?.patient?.patient_email}
                      </p></a> 
                    </div>
                  </div>
                </div>
                <div className="col-3 d-flex flex-column justify-content-center">
                  <button className="btn btn-block notify-btn" onClick={() => setShowModal(true)}>
                    {d["notify"][language]}
                  </button>
                  <button className="btn btn-block unfollow-btn" onClick={handleUnfollow}>
                    {d["stop following"][language]}
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-4">
          {/* maladies */}
          <Card>
            <CardBody style={{ background: "#3453DF", color: "#fff", padding: "2rem" }} >
              <div className="row mb-3">
                <div className="col-12 d-flex align-items-center">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 2.025V3.04375L14.5437 3.0875C13.525 3.18125 11.9875 3.58125 10.925 4.0375C10.65 4.15625 10.4062 4.2375 10.375 4.21875C10.35 4.20625 10.1125 3.8125 9.85 3.35L9.375 2.50625L8.49375 3.0125C7.65 3.49375 7.625 3.51875 7.70625 3.65C7.75625 3.71875 7.9875 4.11875 8.21875 4.525L8.65 5.275L8.46875 5.4C7.34375 6.21875 6.21875 7.34375 5.4 8.475L5.275 8.65L4.525 8.21875C4.11875 7.98125 3.71875 7.75 3.65 7.70625C3.51875 7.625 3.49375 7.65 3.0125 8.49375L2.50625 9.375L3.35 9.85C3.8125 10.1125 4.2 10.35 4.21875 10.375C4.2375 10.4 4.1375 10.6875 4.00625 11.0063C3.5375 12.1313 3.0625 14.0312 3.0625 14.7875V15H2.03125H1V16V17H2.025H3.04375L3.0875 17.4563C3.18125 18.475 3.58125 20.0125 4.0375 21.075C4.15625 21.35 4.2375 21.5938 4.21875 21.625C4.20625 21.65 3.8125 21.8875 3.35 22.15L2.50625 22.625L3.0125 23.5062C3.49375 24.35 3.51875 24.375 3.65 24.2937C3.71875 24.25 4.11875 24.0187 4.525 23.7812L5.275 23.35L5.4 23.525C6.21875 24.6562 7.34375 25.7812 8.46875 26.6L8.65 26.725L8.21875 27.475C7.9875 27.8812 7.75625 28.2812 7.70625 28.35C7.625 28.4813 7.65 28.5062 8.49375 28.9875L9.375 29.4937L9.85 28.65C10.1125 28.1875 10.35 27.8 10.375 27.7812C10.4 27.7687 10.725 27.8812 11.1 28.0312C12.2063 28.475 13.5437 28.8187 14.55 28.9125L15 28.9562V29.975V31H16H17V29.9688V28.9375H17.2125C17.9625 28.9375 19.85 28.4688 20.9937 28C21.3188 27.8625 21.6063 27.7687 21.625 27.7812C21.65 27.8 21.8875 28.1937 22.1562 28.6562C22.6187 29.4812 22.6438 29.5063 22.7688 29.4187C22.8438 29.3687 23.2375 29.1437 23.6438 28.9062C24.35 28.5 24.375 28.4813 24.2938 28.35C24.075 28.0187 23.3625 26.7438 23.3813 26.725C23.3938 26.7125 23.6875 26.4812 24.0312 26.2062C24.975 25.4562 25.8938 24.4938 26.6 23.5312L26.725 23.35L27.475 23.7812C27.8813 24.0125 28.2812 24.2438 28.35 24.2937C28.4813 24.375 28.5063 24.35 28.9875 23.5062L29.4875 22.6312L28.7313 22.1937C27.6187 21.5562 27.7 21.6812 27.9625 21.0813C28.4188 20.0125 28.8188 18.4812 28.9125 17.4563L28.9563 17H29.975H31V16V15H29.975H28.9563L28.9125 14.5437C28.8188 13.5187 28.4188 11.9875 27.9625 10.9187C27.7063 10.325 27.6187 10.45 28.7188 9.8125L29.4875 9.36875L28.9875 8.49375C28.5063 7.65 28.4813 7.625 28.35 7.70625C28.2812 7.75625 27.8813 7.9875 27.475 8.21875L26.725 8.65L26.6 8.46875C25.7688 7.3375 24.6625 6.23125 23.5312 5.4L23.35 5.275L23.7812 4.525C24.0125 4.11875 24.2437 3.71875 24.2938 3.65C24.375 3.51875 24.35 3.5 23.6438 3.09375C23.2375 2.85625 22.8438 2.63125 22.775 2.58125C22.6438 2.5 22.6187 2.525 22.2 3.2625C21.5562 4.375 21.6938 4.29375 21 4.00625C19.85 3.53125 17.9688 3.0625 17.2125 3.0625H17V2.03125V1H16H15V2.025ZM17.175 5.06875C19.2 5.2875 21.2563 6.125 22.8125 7.3625C23.2563 7.71875 24.2313 8.68125 24.5625 9.09375C27.2313 12.45 27.75 17.075 25.8687 20.8187C24.7437 23.0812 23.0813 24.7438 20.8188 25.8688C16.3188 28.125 10.6875 26.8875 7.46875 22.9375C4.75625 19.6062 4.2375 14.9312 6.15625 11.1125C7.48125 8.48125 9.7625 6.49375 12.5437 5.56875C13.2312 5.3375 14.3188 5.10625 14.9688 5.04375C15.525 4.99375 16.6 5.00625 17.175 5.06875Z" fill="white" />
                    <path d="M12.8748 8.09375C11.7748 8.33125 10.6811 9.1875 10.1936 10.2C9.60605 11.4125 9.60605 12.5875 10.1936 13.8C10.8248 15.1125 12.2623 16 13.7498 16C15.2311 16 16.6311 15.1312 17.2998 13.8125C17.8936 12.625 17.8998 11.3812 17.2998 10.1875C16.4936 8.58125 14.6623 7.7125 12.8748 8.09375ZM14.5936 10.1937C14.9873 10.3812 15.3623 10.7562 15.5623 11.1562C15.6873 11.4125 15.7186 11.5625 15.7186 12C15.7123 12.4813 15.6936 12.5687 15.5061 12.925C15.2686 13.3625 15.0686 13.5562 14.5998 13.8C14.3311 13.9375 14.1998 13.9625 13.7498 13.9625C13.3123 13.9688 13.1623 13.9375 12.9061 13.8125C11.2811 13.0125 11.4186 10.7188 13.1248 10.1C13.5186 9.95625 14.1873 10 14.5936 10.1937Z" fill="white" />
                    <path d="M19.2375 14.8938C18.45 15.1625 17.8062 15.725 17.4437 16.4688C17.2062 16.95 17.1312 17.2938 17.125 17.8813C17.125 18.75 17.4625 19.525 18.1 20.125C19.375 21.3125 21.2312 21.2875 22.4375 20.0688C22.6625 19.8438 22.9187 19.5125 23.0125 19.3375C23.925 17.6313 23.0312 15.4438 21.1937 14.875C20.625 14.6938 19.7937 14.7063 19.2375 14.8938ZM20.7375 16.8375C21.3 17.1313 21.5375 17.8188 21.2562 18.3625C20.7375 19.375 19.2312 19.1 19.1375 17.9688C19.0812 17.275 19.55 16.75 20.2375 16.75C20.4187 16.75 20.6437 16.7875 20.7375 16.8375Z" fill="white" />
                    <path d="M11.8691 17.4C10.8504 17.7563 10.0879 18.6 9.84412 19.6313C9.58787 20.7188 9.88787 21.7625 10.6879 22.5625C12.1066 23.9813 14.3566 23.7563 15.5191 22.0688C16.1754 21.1188 16.1691 19.6625 15.5066 18.65C14.9004 17.7188 14.0066 17.25 12.8504 17.25C12.4191 17.25 12.1816 17.2875 11.8691 17.4ZM13.4379 19.375C13.7754 19.5438 13.9566 19.825 13.9879 20.225C14.0254 20.6563 13.9754 20.825 13.7441 21.0875C13.2129 21.7 12.2316 21.5813 11.8816 20.8625C11.6129 20.3063 11.8004 19.7 12.3441 19.3688C12.6004 19.2063 13.1191 19.2125 13.4379 19.375Z" fill="white" />
                  </svg>
                  <span className="ml-2 fs-24">{d["diseases"][language]}:</span>
                </div>

              </div>
              <div className="row">
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">

                  <span className="fs-16 diseases">{d["diabetes"][language]}</span>
                  {data?.patient?.patient_diabets ? <span >{data?.patient?.patient_diabets_type}</span> : d["No"][language]}
                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-16 diseases">{d["hypertension"][language]}</span>
                  {data?.patient?.patient_hypertensive ? <span >{data?.patient?.patient_hypertensive_type}</span> : d["No"][language]}
                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-16 diseases">{d["thyroid"][language]}</span>
                  {data?.patient?.patient_thyroid ? <span >{data?.patient?.patient_thyroid_type}</span> : d["No"][language]}
                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-16 diseases">{d["kidneys"][language]}</span>
                  {data?.patient?.rein ? <span >{data?.patient?.renal_type}</span> : d["No"][language]}

                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-16 diseases">{d["metabolic"][language]}</span>
                  {data?.patient?.metabolic ? <span >{data?.patient?.metabolic_type}</span> : d["No"][language]}


                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-16 diseases">{d["respiratory"][language]}</span>
                  {data?.patient?.respiratoire_chro ? <span >{data?.patient?.respiratoir_type}</span> : d["No"][language]}

                </div>
                <div className="col-6 d-flex justify-content-between align-items-center mb-3">
                  
                  {data?.patient?.maladicronic && <><span className="fs-16 diseases">{d["other"][language]}</span> <span >{data?.patient?.maladicronic}</span></>}

                </div>
              </div>

            </CardBody>
          </Card>
        </div>
      </div>

      <Tab.Container defaultActiveKey={1} className=" d-flex flex-1" >
        <Nav
          as="ul"
          className="patient-tab nav-pills mb-4 justify-content-start"
        >

          <Nav.Item as="li" key={1}>
            <Nav.Link eventKey={1} className="GoldmanSemiBold">
              {d["folder and statistics"][language]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li" key={2}>
            <Nav.Link eventKey={2} className="GoldmanSemiBold">
              {d["objectives"][language]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li" key={3}>
            <Nav.Link eventKey={3} className="GoldmanSemiBold">
              {d["medication"][language]}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li" key={4}>
            <Nav.Link eventKey={4} className="GoldmanSemiBold">
              {d["risk assessment"][language]}
            </Nav.Link>
          </Nav.Item>

        </Nav>
        <Tab.Content className=" bg-white mb-3" style={{ borderRadius: "1rem" }}>
          <Tab.Pane eventKey={1} key={1} className="py-4">

            <Details
              recent={data?.recent_activities} />
          </Tab.Pane>
          <Tab.Pane eventKey={2} key={2} >
            <Objectives />
          </Tab.Pane>
          <Tab.Pane eventKey={3} key={3} >
            <Medication />
          </Tab.Pane>
          <Tab.Pane eventKey={4} key={4} >
            <Risk diabet={data?.diabet} cardio={data?.cardio} />
          </Tab.Pane>

        </Tab.Content>
      </Tab.Container>

    </Fragment >
  );
}

export default PatientDetails;
